<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">Detail {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboards</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{
                  module
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 d-print-none">
        <div class="card shadow-sm mb-4">
          <div class="card-body">
            <div class="mb-4 justify-content-between d-flex">
              <div>
                <div class="d-flex align-items-center">
                  <img
                    v-if="data.usr_photo == null"
                    class="rounded-circle details-employee-user mr-3"
                    src="@/assets/user.png"
                    alt="Header Avatar"
                  />
                  <img
                    v-else
                    class="rounded-circle details-employee-user mr-3"
                    :src="$root.backEnd + data.usr_photo"
                    alt="Header Avatar"
                  />
                  <div>
                    <h5 class="mb-1 font-size-15">
                      {{ data.usr_fullname }}
                    </h5>
                    <span href="#" class="text-muted text-truncate-employee">{{
                      data.usr_email
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="dropdown">
                <button
                  class="btn btn-link dropdown-toggle px-0"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-dots-vertical-rounded text-dark"></i>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a
                    class="dropdown-item"
                    href="javascript:;"
                    @click="getFormCustomers"
                    >Edit</a
                  >
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between border-bottom pb-2 mb-2">
              <div class="">
                <h5 class="font-size-12 text-muted">Status</h5>
                <p class="font-size-12 text-primary mb-0">
                  {{ data.srv_t_status_name }}
                </p>
              </div>
              <!-- <div class="text-right">
                <h5 class="font-size-12 text-muted">Date Buy</h5>
                <p class="text-muted mb-0">
                  {{
                    $moment(data.srv_t_created_at).format("HH:mm DD, MMM YYYY")
                  }}
                </p>
              </div> -->
            </div>

            <div class="justify-content-between d-flex align-items-center mt-3">
              <h5 class="font-size-12 mb-0">Jam Booking</h5>
              <p class="font-weight-bold mb-0">
                <template
                  v-if="
                    typeof data.srv_t_hours_start !== 'undefined' &&
                    data.srv_t_hours_start !== null &&
                    data.srv_t_hours_start !== ''
                  "
                >
                  {{
                    $moment(data.srv_t_hours_start).format("HH:mm, DD-MM-YYYY")
                  }}
                </template>
              </p>
            </div>

            <div class="justify-content-between d-flex align-items-center mt-3">
              <h5 class="font-size-12 mb-0">Total Price</h5>
              <p class="font-weight-bold mb-0">
                Rp {{ $root.numberWithCommas(data.srv_t_actual_price) }}
              </p>
            </div>
            <template v-if="data.srv_t_cat == 4">
              <div class="justify-content-between d-flex align-items-center mt-3">
                <h5 class="font-size-12 mb-0">Pembayaran</h5>
                <p class="font-weight-bold mb-0">
                  Cash
                </p>
              </div>
            </template>
            <template v-else-if="data.pm_origin_data === null">
              <div class="justify-content-between d-flex align-items-center mt-3">
                <h5 class="font-size-12 mb-0">Pembayaran</h5>
                <p class="font-weight-bold mb-0">
                  Tidak Diketahui
                </p>
              </div>
            </template>
            <template v-else>
              <div class="justify-content-between d-flex align-items-center mt-3">
                <h5 class="font-size-12 mb-0">Pembayaran</h5>
                <p class="font-weight-bold mb-0">
                  {{ pm_origin_data.payment_type }}
                </p>
              </div>
              <template v-if="data.pm_trx_status == 'settlement'">
                <div class="justify-content-between d-flex align-items-center mt-3">
                  <h5 class="font-size-12 mb-0">Tanggal Pembayaran</h5>
                  <p class="font-weight-bold mb-0">
                    <template v-if="pm_origin_data.payment_amounts !== undefined">
                      {{ pm_origin_data.payment_amounts[0].paid_at }}
                    </template>
                    <template v-else-if="pm_origin_data.settlement_time !== undefined">
                      {{ pm_origin_data.settlement_time }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </p>
                </div>
              </template>
              <template v-else>
                <div class="justify-content-between d-flex align-items-center mt-3">
                  <h5 class="font-size-12 mb-0">Tanggal Pembayaran</h5>
                  <p class="font-weight-bold mb-0">
                    <template v-if="pm_origin_data.transaction_time !== undefined">
                      {{ pm_origin_data.transaction_time }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </p>
                </div>
              </template>
            </template>

            <template v-if="data.srv_t_cat == 2">
              <div
                class="justify-content-between d-flex align-items-center mt-3"
              >
                <button
                  type="button"
                  @click="approve_true()"
                  :disabled="data.srv_t_approve == 1"
                  class="btn btn-sm btn-primary"
                >
                  Approve
                </button>
                <button
                  type="button"
                  @click="reject_home()"
                  class="btn btn-sm btn-danger"
                >
                  Reject
                </button>
              </div>
            </template>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
            >
              <h4 class="card-title mb-0">Catatan / Keluhan</h4>
            </div>
            <p>{{ data.srv_t_note_users }}</p>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
            >
              <h4 class="card-title mb-0">Info User</h4>
            </div>
            <p class="clearfix">
              <span class="float-left">Brand Mobil</span>
              <span
                class="float-right text-muted"
                v-text="this.data.crs_brand_name"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Mobil</span>
              <span
                class="float-right text-muted"
                v-text="this.data.crs_model_name"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Nomor Polisi</span>
              <span
                class="float-right text-muted"
                v-text="this.data.cst_crs_police_number"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Kilometer</span>
              <span
                class="float-right text-muted"
                v-text="$root.numberWithCommas(this.data.srv_t_km)"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Nama</span>
              <span
                class="float-right text-muted"
                v-text="data.usr_fullname"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Phone</span>
              <span
                class="float-right text-muted"
                v-text="data.usr_phone"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Alamat</span>
              <span
                class="float-right text-muted"
                v-text="data.usr_address"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Estimasi Waktu</span>
              <span
                class="float-right text-muted"
                v-text="data.srv_t_estimated_time"
              ></span>
            </p>
            <p class="clearfix">
              <span class="float-left">Waktu Selesai</span>
              <span
                class="float-right text-muted"
                v-text="data.srv_t_actual_time"
              ></span>
            </p>
          </div>
        </div>

        <template v-if="data.srv_t_cat != 3 && data.srv_t_cat != 2">
          <div class="card">
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
              >
                <h4 class="card-title mb-0">Diambil Oleh</h4>
              </div>

              <p class="clearfix">
                <span class="float-left">Nama</span>
                <span
                  class="float-right text-muted"
                  v-text="data.srv_t_fullname"
                ></span>
              </p>
              <p class="clearfix">
                <span class="float-left">Phone</span>
                <span
                  class="float-right text-muted"
                  v-text="data.srv_t_phone"
                ></span>
              </p>
            </div>
          </div>
        </template>

        <template v-if="data.srv_t_cat == 3 || data.srv_t_cat == 2">
          <div class="card">
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
              >
                <h4 class="card-title mb-0">
                  <template v-if="data.srv_t_cat == 3">
                    Alamat Servis Darurat
                  </template>
                  <template v-if="data.srv_t_cat == 2">
                    Alamat Home Servis
                  </template>
                </h4>
              </div>

              <span v-html="data.srv_t_address"> </span>
            </div>
          </div>
        </template>

        <router-link
          class="btn btn-secondary btn-block waves-effect waves-light"
          :to="{
            name: table_module + '_invoice',
            params: { uuid: data.srv_t_uuid },
          }"
        >
          <i class="fa fa-print"></i> Print Invoice
        </router-link>
        <a
          href="#"
          class="btn btn-primary w-md waves-effect btn-block waves-light"
          >Send Email</a
        >
      </div>
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="updateSrvT">
              <div class="invoice-title">
                <h4 class="float-right font-size-16">
                  Order # {{ data.srv_t_code }}
                </h4>
                <div class="mb-4">
                  <img
                    src="@/assets/images/logo-dark.png"
                    alt="logo"
                    height="20"
                  />
                </div>
              </div>
              <hr />

              <div class="py-2 mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="font-size-15 font-weight-bold">Servis Regular</h3>
                  <button
                    type="button"
                    class="btn btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle btn-secondary"
                    @click="showAddItem('srv')"
                  >
                    <i class="bx bx-plus mr-2"></i> New
                  </button>
                </div>
              </div>
              <div class="invoice-table" style="overflow: auto">
                <table class="table table-nowrap">
                  <thead>
                    <tr>
                      <th style="width: 20px">No</th>
                      <th>Name</th>
                      <th>Estimate Durations</th>
                      <th>Price</th>
                      <th>Diskon</th>
                      <th>Total Price</th>
                      <th>Supplier</th>
                      <th>Supplier Price</th>
                      <th style="width: 20px">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="bind_services.length > 0">
                      <tr
                        v-for="(item, index) in bind_services"
                        :key="'bind_services' + index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          <router-link
                            :to="{
                              name: 'services_detail',
                              params: { uuid: item.srv_uuid },
                            }"
                          >
                            <template v-if="item.srv_name != ''">
                              {{ item.srv_name }}
                            </template>
                            <template v-else> - </template>
                          </router-link>
                        </td>
                        <td>{{ est_time(item.srv_time) }}</td>
                        <td>
                          <div style="display: inline-block; min-width: 150px">
                            <div class="form-group w-100 mb-0">
                              <currency-input
                                :class="'form-control form-control-sm'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                :value="item.srv_act_price"
                                :readonly="readOnlyNotAdmin"
                                @input="
                                  addVarBindChekcOut(
                                    $event,
                                    item.srv_id,
                                    'services',
                                    'srv_act_price'
                                  )
                                "
                              ></currency-input>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style="display: inline-block; min-width: 50px">
                            <div class="form-group w-100 mb-0">
                              <money
                                name="discount_services"
                                :class="'form-control'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                placeholder="Type here"
                                v-bind="money_no_rp"
                                v-model="item.srv_discount"
                                @input="getTotalPrice"
                                :readonly="readOnlyNotAdmin"
                              ></money>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style="display: inline-block; min-width: 50px">
                            <div class="form-group w-100 mb-0">
                              Rp.
                              {{ $root.numberWithCommas(item.srv_total_price) }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style="display: inline-block; min-width: 150px">
                            <v-select
                              label="spr_name"
                              :options="options_supplier[index]"
                              :filterable="false"
                              v-model="item.spr"
                              @input="searchAutocompleteSupplier($event, index)"
                            >
                              <template #no-options
                                >please type supplier</template
                              >
                            </v-select>
                          </div>
                        </td>
                        <td>
                          <template v-if="item.spr !== undefined">
                            <div style="display: inline-block; min-width: 150px">
                              <currency-input
                                :class="'form-control form-control-sm'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                v-model="item.spr.srv_price_act_external"
                                :disabled="!item.spr"
                                :readonly="readOnlyNotAdmin"
                                @input="sprChange($event, index)"
                              ></currency-input>
                            </div>
                          </template>
                        </td>
                        <td>
                          <a
                            href="javascript:;"
                            @click="removeBind('srv', item.srv_id)"
                          >
                            <i class="bx bx-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="10" class="text-center">No data found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <hr />

              <div class="py-2 mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="font-size-15 font-weight-bold">Servis Paket</h3>
                  <button
                    type="button"
                    class="btn btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle btn-secondary"
                    @click="showAddItem('srv_b')"
                  >
                    <i class="bx bx-plus mr-2"></i> New
                  </button>
                </div>
              </div>
              <div class="invoice-table">
                <table class="table table-nowrap">
                  <thead>
                    <tr>
                      <th style="width: 75px">No</th>
                      <th>Name</th>
                      <th>Estimate Durations</th>
                      <th style="width: 175px">Price</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="bind_services_bulk.length > 0">
                      <tr
                        v-for="(item, index) in bind_services_bulk"
                        :key="'bind_services_bulk' + index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          <router-link
                            :to="{
                              name: 'services_bulk_detail',
                              params: { uuid: item.srv_b_uuid },
                            }"
                          >
                            <template v-if="item.srv_b_name != ''">
                              {{ item.srv_b_name }}
                            </template>
                            <template v-else> - </template>
                          </router-link>
                        </td>
                        <td>{{ est_time(item.srv_b_time) }}</td>
                        <td>
                          <div style="display: inline-block; min-width: 150px">
                            <div class="form-group w-100 mb-0">
                              <currency-input
                                :class="'form-control form-control-sm'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                :value="item.srv_b_act_price"
                                :readonly="readOnlyNotAdmin"
                              ></currency-input>
                            </div>
                          </div>
                        </td>
                        <td>
                          <a
                            href="javascript:;"
                            @click="removeBind('srv_b', item.srv_b_id)"
                          >
                            <i class="bx bx-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="10" class="text-center">No data found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <hr />

              <div class="py-2 mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="font-size-15 font-weight-bold">Products</h3>
                  <button
                    type="button"
                    class="btn btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle btn-secondary"
                    @click="showAddItem('prd')"
                  >
                    <i class="bx bx-plus mr-2"></i> New
                  </button>
                </div>
              </div>
              <div class="table-responsive invoice-table">
                <table class="table table-nowrap">
                  <thead>
                    <tr>
                      <th style="width: 75px">No</th>
                      <th>Name</th>
                      <th>Price</th>
                      <th>Quantitiy</th>
                      <th>Satuan</th>
                      <th>Total</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="bind_prd.length > 0">
                      <tr
                        v-for="(item, index) in bind_prd"
                        :key="'bind_prd' + index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          <router-link
                            :to="{
                              name: 'products_detail',
                              params: { uuid: item.prd_uuid },
                            }"
                          >
                            <template v-if="item.prd_name != ''">
                              {{ item.prd_name }}
                            </template>
                            <template v-else> - </template>
                          </router-link>
                        </td>
                        <td>
                          <div style="display: inline-block; min-width: 150px">
                            <div class="form-group w-100 mb-0">
                              <currency-input
                                :class="'form-control form-control-sm'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                v-model="item.prd_act_price"
                                :readonly="readOnlyNotAdmin"
                                @input="
                                  addVarBindChekcOut(
                                    $event,
                                    item.prd_id,
                                    'products'
                                  )
                                "
                              ></currency-input>
                            </div>
                          </div>
                        </td>
                        <td>
                          <vue-number-input
                            v-model="item.prd_qty"
                            :min="1"
                            :max="item.prd_stock + item.qty_on_buy"
                            size="small"
                            :inputtable="false"
                            inline
                            center
                            controls
                            @change="
                              addVarBindChekcOut(
                                $event,
                                item.prd_id,
                                'products'
                              )
                            "
                          ></vue-number-input>
                        </td>
                        <td>{{ item.prd_unit }}</td>
                        <td>
                          <div style="display: inline-block; min-width: 150px">
                            Rp
                            {{ $root.numberWithCommas(item.prd_total_price) }}
                          </div>
                        </td>
                        <td>
                          <a
                            href="javascript:;"
                            @click="removeBind('prd', item.prd_id)"
                          >
                            <i class="bx bx-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="10" class="text-center">No data found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <hr />

              <div class="row">
                <div class="col-12 mt-2">
                  <strong>Teknisi</strong>
                  <div class="form-group w-100 mb-0">
                    <s_autocomplete_form
                      name="emp_id"
                      :table_module="table_module"
                      :validation="empRequired"
                      dropdown_name="emp_id"
                      :content="data.emp"
                      @post="bindingData"
                    ></s_autocomplete_form>
                  </div>
                </div>
                <template v-if="data.srv_t_cat == 4">
                  <div class="col-12 mt-2">
                    <strong>Catatan / Keluhan</strong>
                    <div class="form-group w-100 mb-0">
                      <textarea
                        type="text"
                        rows="3"
                        placeholder="Type here..."
                        v-model="data.srv_t_note_users"
                        class="form-control"
                      ></textarea>
                    </div>
                  </div>
                </template>
                <div class="col-12 mt-2">
                  <strong>Notes</strong>
                  <div class="form-group w-100 mb-0">
                    <textarea
                      type="text"
                      rows="3"
                      placeholder="Type here..."
                      v-model="data.srv_t_note"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <strong>Status Pesanan</strong>
                  <div class="form-group w-100 mb-0">
                    <select
                      class="form-control form-control-sm"
                      :disabled="disableStatus"
                      v-model="data.srv_t_status"
                      name="srv_t_status"
                      id="srv_t_status"
                      :required="true"
                    >
                      <option
                        :value="parseInt(item_options_status.dd_o_value)"
                        v-for="(
                          item_options_status, index_options_status
                        ) in options_status"
                        :key="index_options_status + '_srv_t_status'"
                      >
                        {{ item_options_status.dd_o_label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <strong>Total Harga</strong>
                  <div class="form-group w-100 mb-0">
                    <currency-input
                      :class="'form-control form-control-sm'+((readOnlyNotAdmin) ? ' readonly' : '')"
                      v-model="data.srv_t_actual_price"
                      :readonly="readOnlyNotAdmin"
                    ></currency-input>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <strong>Kategori Pesanan</strong>
                  <div class="form-group w-100 mb-0">
                    <select
                      class="form-control form-control-sm"
                      v-model="data.srv_t_cat"
                      name="srv_t_cat"
                      id="srv_t_cat"
                      :required="true"
                      :disabled="readOnlyNotAdmin"
                    >
                      <option
                        :value="parseInt(item_options_cat.dd_o_value)"
                        v-for="(
                          item_options_cat, index_options_cat
                        ) in options_cat"
                        :key="index_options_cat + '_srv_t_cat'"
                      >
                        {{ item_options_cat.dd_o_label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <strong>DP</strong>
                  <div class="form-group w-100 mb-0">
                    <currency-input
                      :class="'form-control form-control-sm'+((readOnlyNotAdmin) ? ' readonly' : '')"
                      v-model="data.srv_t_dp"
                      @input="getTotalPrice"
                      :readonly="readOnlyNotAdmin"
                    ></currency-input>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <strong>Kilometer</strong>
                  <div class="form-group w-100 mb-0">
                    <money
                      name="srv_t_km"
                      class="form-control"
                      placeholder="Type here"
                      v-bind="money_no_rp"
                      v-model="data.srv_t_km"
                    ></money>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <strong>Sisa Pembayaran</strong>
                  <div class="form-group w-100 mt-2 mb-0">
                    Rp.{{ $root.numberWithCommas(getSisaPembayaran) }}
                  </div>
                </div>
              </div>

              <div
                class="d-flex align-items-center justify-content-end my-4 border-top"
              >
                <button
                  type="button"
                  @click="fetchDataDetail"
                  class="btn btn-danger w-50"
                >
                  Reset
                </button>
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn btn-info ml-2 w-50"
                  :disabled="disabled"
                >
                  <template v-if="disabled">
                    <b-spinner small type="grow"></b-spinner>
                    Loadung ..
                  </template>
                  <template v-else> Update </template>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <b-sidebar
      :visible="visibleEditCustomer"
      id="sidebar-edit-customers"
      title="Edit Customers"
      backdrop-variant="dark"
      backdrop
      shadow
      right
      @hidden="visibleEditCustomer = false"
    >
      <div class="px-3 py-2">
        <form class="form-sample" @submit.prevent="updateCustomers()">
          <!-- <p class="card-description">Personal info</p> -->
          <div class="row">
            <div
              class="col-md-12"
              v-for="(item, index) in fieldsCustomers"
              :key="index + '_fieldsCustomers'"
            >
              <div class="form-group">
                <label>{{ item["usr_f_label"] }}</label>
                <small
                  v-if="item['usr_f_validation'] != ''"
                  class="pull-right text-danger"
                  >*{{ item["usr_f_validation"] }}</small
                >
                <component
                  :is="item['usr_f_input_type'] + '_form'"
                  :name="item['usr_f_name']"
                  :validation="item['usr_f_validation']"
                  :content="item['content']"
                  :dropdown_name="item['usr_f_options']"
                  @post="bindingDataCustomers"
                ></component>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary mr-2">Update</button>
          <button
            type="button"
            class="btn btn-danger"
            @click="visibleEditCustomer = false"
          >
            Cancel
          </button>
        </form>
      </div>
    </b-sidebar>

    <b-sidebar
      v-if="visibleAddItem"
      :visible="visibleAddItem"
      id="sidebar-add-item"
      title="Add Item"
      backdrop-variant="dark"
      backdrop
      shadow
      left
      @hidden="visibleAddItem = false"
      width="500px"
    >
      <div class="p-2">
        <div class="row">
          <loading
            :active.sync="isLoadingAddItem"
            :is-full-page="false"
            :height="45"
            :width="45"
            color="#398BD7"
          ></loading>
          <template v-if="data_srv !== null">
            <div class="col-md-12">
              <b-form-input
                v-model="searchSrvName"
                @input="addItem('srv')"
                placeholder="Search Servis Regular..."
                type="text"
              ></b-form-input>
            </div>

            <div
              class="col-md-12 mt-2"
              v-for="(item, index_srv) in data_srv"
              :key="index_srv"
            >
              <div class="card shadow-sm mb-2">
                <div class="card-body">
                  <div class="mb-2 justify-content-between d-flex">
                    <div>
                      <small class="text-muted">{{ item.srv_code }}</small>
                      <h5 class="font-size-15">
                        <a href="javascript:;" class="text-dark">{{
                          item.srv_name
                        }}</a>
                      </h5>
                    </div>
                    <div class="form-check mr-2">
                      <input
                        class="form-check-input mx-0"
                        type="checkbox"
                        :value="item"
                        :id="'srv_checkbox_' + index_srv"
                        @change="pushItem($event, 'srv', item)"
                        :checked="checkExist('srv', item.srv_id)"
                      />
                      <label
                        class="form-check-label mx-0"
                        :for="'srv_checkbox_' + index_srv"
                      ></label>
                    </div>
                  </div>

                  <p class="font-size-12 text-muted">
                    {{
                      item.srv_description != null ? item.srv_description : "-"
                    }}
                  </p>

                  <div class="d-flex justify-content-between">
                    <div class>
                      <h5 class="font-size-12 text-muted">Price</h5>
                      <p class="font-size-12 text-primary mb-0">
                        <b>Rp {{ $root.numberWithCommas(item.srv_price) }}</b>
                      </p>
                    </div>
                    <div class="text-right">
                      <h5 class="font-size-12 text-muted">
                        Estimate Durations
                      </h5>
                      <p class="text-muted mb-0">
                        {{ est_time(item.srv_time) }}
                        <i class="bx bx-calendar-check ml-1 text-primary"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-if="data_srv_b !== null">
            <div class="col-md-12">
              <b-form-input
                v-model="searchSrvBName"
                @input="addItem('srv_b')"
                placeholder="Search Servis Regular..."
                type="text"
              ></b-form-input>
            </div>

            <div
              class="col-md-12 mt-2"
              v-for="(item, index_srv_b) in data_srv_b"
              :key="index_srv_b"
            >
              <div class="card shadow-sm mb-2">
                <div class="card-body">
                  <div class="mb-2 justify-content-between d-flex">
                    <div>
                      <h5 class="font-size-15">
                        <a href="javascript:;" class="text-dark">{{
                          item.srv_b_name
                        }}</a>
                      </h5>
                    </div>
                    <div class="form-check mr-2">
                      <input
                        class="form-check-input mx-0"
                        type="checkbox"
                        :value="item.srv_b_id"
                        :id="'srv_b_checkbox_' + index_srv_b"
                        :checked="checkExist('srv_b', item.srv_b_id)"
                        @change="pushItem($event, 'srv_b', item)"
                      />
                      <label
                        class="form-check-label mx-0"
                        :for="'srv_b_checkbox_' + index_srv_b"
                      ></label>
                    </div>
                  </div>

                  <template
                    v-if="
                      item.srv_b_description != '' &&
                      item.srv_b_description != null
                    "
                  >
                    <read-more
                      more-str="Read More"
                      :text="item.srv_b_description"
                      link="#"
                      less-str="Read Less"
                      :maxChars="350"
                    ></read-more>
                  </template>
                  <p class="font-size-12 text-muted" v-else>-</p>

                  <div class="d-flex justify-content-between mt-3">
                    <div class>
                      <h5 class="font-size-12 text-muted">Price</h5>
                      <p class="font-size-12 text-primary mb-0">
                        <b>Rp {{ $root.numberWithCommas(item.srv_b_price) }}</b>
                      </p>
                    </div>
                    <div class="text-right">
                      <h5 class="font-size-12 text-muted">
                        Estimate Durations
                      </h5>
                      <p class="text-muted mb-0">
                        {{ est_time(item.srv_b_time) }}
                        <i class="bx bx-calendar-check ml-1 text-primary"></i>
                      </p>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </template>

          <template v-if="data_prd !== null">
            <div class="col-md-12">
              <b-form-input
                v-model="searchProductsName"
                @input="addItem('prd')"
                placeholder="Search produk..."
                type="text"
              ></b-form-input>
            </div>
            <div
              class="card col-md-12 mt-2"
              v-for="(item, index_data_prd) in data_prd"
              :key="index_data_prd + '_random_num'"
            >
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <template v-if="item.prd_image !== undefined">
                      <img
                        v-if="item.prd_image.length > 0"
                        class="rounded-circle details-employee-user mr-3"
                        :src="$root.backEnd + item.prd_image[0].prd_r_img_name"
                        alt="Header Avatar"
                      />
                    </template>
                    <div class>
                      <small class="text-muted">{{ item.prd_sku }}</small>
                      <h5 class="font-size-15">
                        <a href="#" class="text-dark">{{ item.prd_name }}</a>
                      </h5>
                      <!-- <router-link
                        v-for="(item_crs, index_crs) in item.crs_model_id" :key="index_crs"
                        :to="{
                          name: 'cars_model_detail',
                          params: { uuid: item_crs['crs_model_uuid'] },
                      }">
                        {{ item_crs.crs_model_name }}
                        <template v-if="item.crs_model_id.length != index_crs + 1">
                          ,
                        </template>
                      </router-link> -->
                    </div>
                  </div>
                  <div class="form-check mr-2 mb-0">
                    <input
                      class="form-check-input mx-0"
                      type="checkbox"
                      :value="item"
                      :id="'srv_products_' + index_data_prd"
                      :checked="checkExist('prd', item.prd_id)"
                      @change="pushItem($event, 'prd', item)"
                      :disabled="item.prd_stock < 1"
                    />
                    <label
                      class="form-check-label mx-0"
                      :for="'srv_products_' + index_data_prd"
                    ></label>
                  </div>
                </div>
                <hr />
                <div
                  class="justify-content-between d-flex align-items-center mt-3"
                >
                  <div class="col-sm-3">
                    <h5 class="font-size-12 text-muted">Category</h5>
                    <p class="font-size-12 mb-0">
                      {{ item.prd_c_name }}
                    </p>
                  </div>
                  <div class="col-sm-3">
                    <h5 class="font-size-12 text-muted">Brand</h5>
                    <p class="font-size-12 mb-0">
                      {{ item.brd_name }}
                    </p>
                  </div>
                  <div class="col-sm-3">
                    <h5 class="font-size-12 text-muted">Stock</h5>
                    <p class="font-size-12 mb-0">
                      <b>{{ item.prd_stock+' '+item.prd_unit }}</b>
                    </p>
                  </div>
                  <div class="col-sm-3">
                    <h5 class="font-size-12 text-muted">Price</h5>
                    <p class="font-size-12 text-primary mb-0">
                      <b>Rp {{ $root.numberWithCommas(item.prd_purchase) }}</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <template v-if="data_srv !== null">
          <div class="row">
            <div class="col-lg-12" v-if="total_page_srv > 1">
              <paginate
                v-model="page_srv"
                :pageCount="parseInt(total_page_srv)"
                :initial-page="page_srv"
                :click-handler="startPaginateSrv"
                prevText="<i class='mdi mdi-chevron-left'></i>"
                nextText="<i class='mdi mdi-chevron-right'></i>"
                container-class="pagination pagination-rounded justify-content-center mt-4"
                pageClass="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
              ></paginate>
            </div>
          </div>
        </template>
        <template v-if="data_srv_b !== null">
          <div class="row">
            <div class="col-lg-12" v-if="total_page_prd > 1">
              <paginate
                v-model="page_prd"
                :pageCount="parseInt(total_page_prd)"
                :initial-page="page_prd"
                :click-handler="startPaginatePrd"
                prevText="<i class='mdi mdi-chevron-left'></i>"
                nextText="<i class='mdi mdi-chevron-right'></i>"
                container-class="pagination pagination-rounded justify-content-center mt-4"
                pageClass="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
              ></paginate>
            </div>
          </div>
        </template>
        <template v-if="data_prd !== null">
          <div class="row">
            <div class="col-lg-12" v-if="total_page_prd > 1">
              <paginate
                v-model="page_prd"
                :pageCount="parseInt(total_page_prd)"
                :initial-page="page_prd"
                :click-handler="startPaginatePrd"
                prevText="<i class='mdi mdi-chevron-left'></i>"
                nextText="<i class='mdi mdi-chevron-right'></i>"
                container-class="pagination pagination-rounded justify-content-center mt-4"
                pageClass="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
              ></paginate>
            </div>
          </div>
        </template>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import VueNumberInput from "@chenfengyuan/vue-number-input";

import { _ } from "vue-underscore";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import email_form from "@/components/input/email";
import s_image_form from "@/components/input/s_image";
import { Money } from "v-money";

export default {
  data() {
    return {
      module: "Transaksi Servis",
      table_module: "services_transaction",
      alias_table: "srv_t",
      alias_table_rel: "srv_t_r",
      data: {
        emp: {},
        srv_t_note_users : ''
      },
      data_dummy: null,
      post: {},
      post_customers: {},
      uuid: this.$route.params.uuid,
      options_status: [],
      options_cat: [],
      isLoading: true,
      visibleEditCustomer: false,
      visibleAddItem: false,
      options_supplier: [],
      fieldsCustomers: [],
      data_srv: null,
      page_srv: 1,
      limit: 10,
      totalData_srv: 0,
      total_page_srv: 0,
      data_srv_b: null,
      page_srv_b: 1,
      totalData_srv_b: 0,
      total_page_srv_b: 0,
      data_prd: null,
      page_prd: 1,
      totalData_prd: 0,
      total_page_prd: 0,
      searchProductsName: "",
      searchSrvName: "",
      searchSrvBName: "",
      money_no_rp: {
        thousands: ".",
        prefix: "",
        precision: 0,
      },
      disabled: false,
      isLoadingAddItem : false
    };
  },
  components: {
    VueNumberInput,
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    email_form,
    s_image_form,
    Money,
  },
  computed: {
    pm_origin_data() {
      let res = {}
      if(typeof this.data.pm_origin_data != undefined && this.data.pm_origin_data != null)
      {
        res = JSON.parse(this.data.pm_origin_data)
      }

      return res;
    },
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
    bind_services() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Service";
        });
        
        result.forEach((element, key) => {
          if(typeof element.spr_id !== 'undefined' && element.spr_id != 0 && Array.isArray(element.spr_id))
          {
            this.$set(this.options_supplier, key, element.spr_id)
          }
        });
        // for (const key in result) {
        //   result[key]["spr"] = [];
        //   if (typeof result[key]["spr_id"] !== "undefined"&& result[key]["spr_id"] != null) {
        //     result[key]["spr"] = {
        //       spr_id: result[key]["spr_id"],
        //       spr_name: result[key]["spr_name"],
        //     };
        //   }
        // }
      }
      return result;
    },
    bind_services_bulk() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Service Bulk";
        });
      }
      return result;
    },
    bind_prd() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Products";
        });
      }
      return result;
    },
    empRequired: function () {
      var res = null;

      if (this.bind_services.length > 0 || this.bind_services_bulk.length > 0) {
        res = "required";
      }

      return res;
    },
    getSisaPembayaran() {
      let result = 0;
      if (
        typeof this.data.srv_t_actual_price !== "undefined" &&
        this.data.srv_t_actual_price !== null &&
        this.data.srv_t_actual_price !== ""
      ) {
        result = this.data.srv_t_actual_price - this.data.srv_t_dp;
      }

      return result;
    },
    disableStatus() {
      let ret = false;
      if (typeof this.data_dummy !== "undefined" && this.data_dummy !== null) {
        let dummy = JSON.parse(this.data_dummy);

        if (dummy.srv_t_cat == 2 || dummy.srv_t_cat == 1) 
        {
          if (dummy.pm_trx_status === null || dummy.pm_trx_status === "") {
            ret = true;
          } else if (dummy.srv_t_cat == 2 && dummy.srv_t_approve == 0) {
            ret = true;
          } else if (dummy.srv_t_status == 4) {
            ret = true;
          }          
        }
      }

      return ret;
    },
    readOnlyNotAdmin(){
      let result = true;

      if(this.local_users.usr_admin != '')
      {
        result = false;
      }

      return result;
    },
  },
  mounted() {
    this.fetchDataDetail();

    this.axios
      .get("/dropdown/list/srv_t_status_id")
      .then((response) => {
        this.options_status = response.data.data;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            console.log("error 500");
          }
        }
      });

    this.axios
      .get("/dropdown/list/srv_t_cat_id")
      .then((response) => {
        this.options_cat = response.data.data;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            console.log("error 500");
          }
        }
      });
  },
  methods: {
    approve_true() {
      this.isLoading = true;
      this.axios
        .post(this.table_module + "/approved", { uuid: this.uuid })
        .then(() => {
          this.isLoading = false;
          this.$toast.success("Approved Success!!");
          this.$root.runSocketHome(this.data);
          this.fetchDataDetail();
        })
        .catch((error) => {
          if (error.response) {
            console.log("Error", error.message);
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
          this.isLoading = false;
          this.$toast.error("Failed Data!!");
        });
    },
    reject_home() {
      this.isLoading = true;
      this.axios
        .post(this.table_module + "/reject_home", { uuid: this.uuid })
        .then(() => {
          this.isLoading = false;
          this.$toast.success("Rejects Success!!");
          this.fetchDataDetail();
        })
        .catch((error) => {
          if (error.response) {
            console.log("Error", error.message);
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
          this.isLoading = false;
          this.$toast.error("Failed Data!!");
        });
    },
    onlyNumber($event) {
      console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    fetchDataDetail: function () {
      this.axios
        .get(this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.data["emp"] = {
            emp_id: this.data["emp_id"],
            emp_name: this.data["emp_name"],
          };
          this.data_dummy = JSON.stringify(this.data);
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    est_time(arm) {
      var res = "";
      if (arm != null) {
        var arr = arm.split(":");
        res += arr[0] + " Hours ";
        res += arr[1] + " Minutes";
      }
      return res;
    },
    searchAutocompleteSupplier: function (val, index=null) {
      this.$set(this.bind_services[index]['spr'], 'srv_price_est_external', val.srv_price_external);
      this.$set(this.bind_services[index]['spr'], 'srv_price_act_external', val.srv_price_external);
    },
    sprChange: function(val, index=null) {
      this.$set(this.bind_services[index]['spr'], 'srv_price_act_external', val);
    },
    bindingData: function (value) {
      if (value["value"] == null || value["value"] === "") {
        this.$delete(this.data, value["name"]);
      } else {
        if (value["name"] == "emp_id") {
          this.$delete(this.data, "emp");
          var result = {
            emp_id: value["value"].emp_id,
            emp_name: value["value"].emp_name,
          };
          this.$set(this.data, "emp", result);
        }
      }
    },
    parseArray: function (value) {
      var result = [];
      if (value != null && value != "") {
        result = JSON.parse(value);
      }

      return result;
    },
    getFormCustomers() {
      this.post_customers = {};
      this.axios
        .get("/users/edit/" + this.data.usr_uuid)
        .then((response) => {
          this.fieldsCustomers = response.data.data;
          this.visibleEditCustomer = true;
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    bindingDataCustomers: function (value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post_customers, value["name"]);
      } else {
        this.$set(this.post_customers, value["name"], value["value"]);
      }
    },
    updateCustomers: function () {
      const uuid = this.data.usr_uuid;

      this.axios
        .post("/users/updatebyAdmin/" + uuid, this.post_customers)
        .then((response) => {
          if (response.data.status == 200) {
            this.$toast("Update data berhasil");
            this.visibleEditCustomer = false;
          }
        });
    },
    startPaginateSrv: function (pageNum) {
      this.page_srv = pageNum;
      this.isLoadingAddItem = true;
      this.addItem("srv", true);
    },
    startPaginateSrvB: function (pageNum) {
      this.page_srv_b = pageNum;
      this.isLoadingAddItem = true;
      this.addItem("srv_b", true);
    },
    startPaginatePrd: function (pageNum) {
      this.page_prd = pageNum;
      this.isLoadingAddItem = true;
      this.addItem("prd", true);
    },
    showAddItem: function (module=""){
      this.visibleAddItem = true;
      this.isLoadingAddItem = true;
      this.searchSrvName = ""
      this.searchSrvBName = ""
      this.searchProductsName = ""
      this.addItem(module)
    },
    addItem: _.debounce(function (module = "", next_page = false) {
      var params = {};
      var met = "";

      this.data_srv = null;
      this.data_srv_b = null;
      this.data_prd = null;

      if (this.searchSrvName !== "" && next_page === false) {
        this.page_srv = 1;
      } else if (this.searchSrvBName !== "" && next_page === false) {
        this.page_srv_b = 1;
      } else if (this.searchProductsName !== "" && next_page === false) {
        this.page_prd = 1;
      }

      if (this.searchSrvName == "" && next_page === false) {
        this.page_srv = 1;
      } else if (this.searchSrvBName == "" && next_page === false) {
        this.page_srv_b = 1;
      } else if (this.searchProductsName == "" && next_page === false) {
        this.page_prd = 1;
      }

      if (module == "srv") {
        params = {
          ["search[srv_name]"]: this.searchSrvName,
          ["filter[crs_model_id]"]:
            this.data.crs_model_id == 0 ? 1 : this.data.crs_model_id,
          page: this.page_srv,
        };

        met = "srv_id";
      } else if (module == "srv_b") {
        params = {
          ["search[srv_b_name]"]: this.searchSrvBName,
          ["filter[crs_model_id]"]:
            this.data.crs_model_id == 0 ? 1 : this.data.crs_model_id,
          page: this.page_srv_b,
        };

        met = "srv_b_id";
      } else if (module == "prd") {
        params = {
          ["special_search"]: this.searchProductsName,
          ["filter[crs_model_id]"]:
            this.data.crs_model_id == 0 ? 1 : this.data.crs_model_id,
          page: this.page_prd,
        };

        met = "prd_id";
      }

      params["show"] = this.limit;
      this.axios
        .get("/dropdown/autocomplete/" + met, { params: params })
        .then((response) => {
          this.isLoadingAddItem = false;
          if (module == "srv") {
            this.data_srv = response.data.data.data;
            this.page_srv = response.data.data.current_page;
            this.totalData_srv = response.data.data.total_data;
            this.total_page_srv = response.data.data.total_page;
          } else if (module == "srv_b") {
            this.data_srv_b = response.data.data.data;
            this.page_srv_b = response.data.data.current_page;
            this.totalData_srv_b = response.data.data.total_data;
            this.total_page_srv_b = response.data.data.total_page;
          } else if (module == "prd") {
            this.data_prd = response.data.data.data;
            this.page_prd = response.data.data.current_page;
            this.totalData_prd = response.data.data.total_data;
            this.total_page_prd = response.data.data.total_page;
          }

          this.isLoadingSrv = false;
          this.isLoadingSrvB = false;
          this.isLoadingPrd = false;
        })
        .catch((error) => {
          this.isLoadingAddItem = false;
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    runServices: function () {},
    checkExist: function (module = "", id = "") {
      var result = false;
      var dataCheck = null;
      if (module == "srv_b") {
        dataCheck = this.bind_services_bulk;
      } else if (module == "srv") {
        dataCheck = this.bind_services;
      } else if (module == "prd") {
        dataCheck = this.bind_prd;
      }

      let find = dataCheck.findIndex((r) => r[module + "_id"] == id);

      if (find >= 0) {
        result = true;
      }

      return result;
    },
    pushItem: function (evt, module = "", item = "") {
      var id = "";
      if (evt.target.checked) {
        // var key = this.data.srv_t_r.length;
        if (module == "srv_b") {
          item["srv_t_d_type_name"] = "Service Bulk";
          item["srv_t_r_srv_b_list"] = JSON.stringify(item.srv_id);
          item["srv_b_act_price"] = item.srv_b_price;
          this.data.srv_t_r.push(item);
        } else if (module == "srv") {
          item["srv_act_price"] = item.srv_price;
          item["srv_t_d_type_name"] = "Service";
          this.data.srv_t_r.push(item);
        } else if (module == "prd") {
          item["srv_t_d_type_name"] = "Products";
          item["prd_act_price"] = item.prd_purchase;
          item["prd_qty"] = 1;
          this.data.srv_t_r.push(item);
        }
      } else {
        if (module == "srv_b") {
          id = item[module + "_id"];
          let find = this.data.srv_t_r.findIndex(
            (r) => r[module + "_id"] == id
          );

          if (find >= 0) {
            this.$delete(this.data.srv_t_r, find);
          }
        } else if (module == "srv") {
          id = item[module + "_id"];
          let find = this.data.srv_t_r.findIndex(
            (r) => r[module + "_id"] == id
          );

          if (find >= 0) {
            this.$delete(this.data.srv_t_r, find);
          }
        } else if (module == "prd") {
          id = item[module + "_id"];
          let find = this.data.srv_t_r.findIndex(
            (r) => r[module + "_id"] == id
          );

          if (find >= 0) {
            this.$delete(this.data.srv_t_r, find);
          }
        }
      }

      this.getTotalPrice();
    },
    addVarBindChekcOut: function (evt, id, module_rel, name) {
      var value = "";
      // if (name == "srv_act_price" || name == "srv_price_act_external") {
      //   value = evt;
      // } else {
      //   value = evt.target.value;
      // }
      value = evt;

      if (module_rel == "services") {
        let find = this.data.srv_t_r.findIndex((r) => r["srv_id"] == id);

        if (find != -1) {
          this.$set(this.data.srv_t_r[find], name, value);
        }
      }

      if (module_rel == "services_bulk") {
        let find = this.data_srv_b.findIndex((r) => r["srv_b_id"] == id);

        if (find != -1) {
          this.$set(this.data_srv_b[find], name, value);
        }
      }

      if (module_rel == "products") {
        let find = this.data.srv_t_r.findIndex((r) => r["prd_id"] == id);

        if (find != -1) {
          var price = this.data.srv_t_r[find]["prd_act_price"];
          var qty = this.data.srv_t_r[find]["prd_qty"];
          var total = price * qty;
          // this.data.srv_t_r[find]['76'] = total

          this.$set(this.data.srv_t_r[find], "prd_total_price", total);
        }
      }

      this.getTotalPrice();
    },
    getTotalPrice: function () {
      var res = 0;
      if (this.bind_prd.length > 0) {
        this.bind_prd.forEach((element) => {
          res += element.prd_total_price;
        });
      }

      if (this.bind_services.length > 0) {
        this.bind_services.forEach((element, key) => {
          res +=
            element.srv_act_price -
            (element.srv_act_price * element.srv_discount) / 100;
          this.$set(
            this.bind_services[key],
            "srv_total_price",
            element.srv_act_price -
              (element.srv_act_price * element.srv_discount) / 100
          );
        });
      }

      if (this.bind_services_bulk.length > 0) {
        this.bind_services_bulk.forEach((element) => {
          res += element.srv_b_act_price;
        });
      }

      this.$set(this.data, "srv_t_actual_price", res);
      this.$set(this.data, "srv_t_estimated_price", res);
    },
    updateSrvT: function () {
      this.disabled = true;
      var param = {};

      param["srv_t_id"] = this.data.srv_t_id;
      param["srv_t_status"] = this.data.srv_t_status;
      param["srv_t_cat"] = this.data.srv_t_cat;
      param["srv_t_dp"] = this.data.srv_t_dp;
      param["srv_t_km"] = this.data.srv_t_km;
      param["srv_t_note"] = this.data.srv_t_note;
      param["emp_id"] = this.data.emp.emp_id;
      param["srv_t_actual_price"] = this.data.srv_t_actual_price;
      param["srv_t_estimated_price"] = this.data.srv_t_estimated_price;
      param["post_services"] = this.bind_services;
      param["post_services_bulk"] = this.bind_services_bulk;
      param["post_products"] = this.bind_prd;
      param["srv_t_note_users"] = this.data.srv_t_note_users;

      if (
        this.bind_services.length == 0 &&
        this.bind_services_bulk.length == 0 &&
        this.bind_prd.length == 0 &&
        this.data.srv_t_cat != 3
      ) {
        this.$toast.error("Pilih salah satu produk!!");
        return false;
      }

      this.axios
        .post("/" + this.table_module + "/update/" + this.uuid, param)
        .then((response) => {
          this.disabled = false;
          if (response.data.status == 200) {
            this.$toast("Update data berhasil");
            this.$router.push({ name: this.table_module });

            let dummy = JSON.parse(this.data_dummy);
            if (dummy.srv_t_status != this.data.srv_t_status) {
              this.$root.runSocket(this.data);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.disabled = false;
          this.$toast.error("Update data gagal");
        });
    },
    removeBind: function (table_module, id) {
      if (table_module == "srv_b") {
        let find = this.data.srv_t_r.findIndex(
          (r) => r[table_module + "_id"] == id
        );

        if (find >= 0) {
          this.$delete(this.data.srv_t_r, find);
        }
      } else if (table_module == "srv") {
        let find = this.data.srv_t_r.findIndex(
          (r) => r[table_module + "_id"] == id
        );

        if (find >= 0) {
          this.$delete(this.data.srv_t_r, find);
        }
      } else if (table_module == "prd") {
        let find = this.data.srv_t_r.findIndex(
          (r) => r[table_module + "_id"] == id
        );

        if (find >= 0) {
          this.$delete(this.data.srv_t_r, find);
        }
      }

      this.getTotalPrice();
    },
  },
};
</script>